import { defineStore } from "pinia";

const useStore = defineStore('storeId', {
  state: () => ({
    currentSlideIndex: 0, // 初始值为0
  })
})

export default useStore;